import { FOOTER_MJML } from "../common/footer";
import { PRODUCT_HEADER } from "../common/header";

export const productFeedback = `
<mjml>
  <mj-head>
    <mj-title>Your Feedback Matters to Us</mj-title>
    <mj-preview>We'd love to hear about your experience with {{product_name}}</mj-preview>
    <mj-attributes>
      <mj-all font-family="Arial, sans-serif" />
      <mj-text font-size="16px" color="#333333" line-height="1.5" />
    </mj-attributes>
    <mj-style>
      .rating-container {
        border: 1px solid #e0e0e0;
        border-radius: 8px;
        background-color: #ffffff;
      }
      .rating-button {
        display: inline-block;
        width: 40px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        margin: 0 5px;
        font-size: 20px;
        border-radius: 50%;
        color: #1890ff;
        border: 2px solid #1890ff;
        text-decoration: none;
        font-weight: bold;
      }
      .quote-box {
        border-left: 4px solid #1890ff;
        padding-left: 15px;
        font-style: italic;
      }
      .feedback-option:hover {
        background-color: #f5f5f5;
      }
    </mj-style>
  </mj-head>
  <mj-body background-color="#f5f5f5">
    ${PRODUCT_HEADER(
      "We Value Your Feedback",
      "Help us improve {{product_name}}"
    )}
    
    <mj-section background-color="#ffffff" padding="30px" border-radius="8px">
      <mj-column>
        <mj-text font-size="22px" color="#333333" font-family="Arial, sans-serif">Hello {{first_name}},</mj-text>
        <mj-text font-size="16px" color="#555555" font-family="Arial, sans-serif">
          Thank you for using {{product_name}}. We're committed to providing the best possible experience, and your feedback is essential to help us improve.
        </mj-text>
        <mj-text font-size="16px" color="#555555" font-family="Arial, sans-serif">
          Could you take a moment to share your thoughts? It will only take about 2 minutes of your time.
        </mj-text>
      </mj-column>
    </mj-section>
    
    <!-- Quick Rating Section -->
    <mj-section background-color="#ffffff" padding="20px 30px" border-radius="8px">
      <mj-column>
        <mj-text font-size="18px" color="#333333" font-weight="bold">How would you rate your overall experience?</mj-text>
        <mj-spacer height="10px" />
      </mj-column>
    </mj-section>
    
    <mj-section background-color="#ffffff" padding="0 30px 30px" border-radius="8px" css-class="rating-container">
      <mj-column width="100%">
        <mj-text align="center" padding-bottom="10px">
          <a href="{{feedback_url}}?rating=1" class="rating-button" style="background-color: #FFEBEE;">1</a>
          <a href="{{feedback_url}}?rating=2" class="rating-button" style="background-color: #FFEDE9;">2</a>
          <a href="{{feedback_url}}?rating=3" class="rating-button" style="background-color: #FFF8E1;">3</a>
          <a href="{{feedback_url}}?rating=4" class="rating-button" style="background-color: #E8F5E9;">4</a>
          <a href="{{feedback_url}}?rating=5" class="rating-button" style="background-color: #E0F7FA;">5</a>
        </mj-text>
        <mj-text align="center" font-size="14px" color="#777777" padding-top="0">
          Not satisfied&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Very satisfied
        </mj-text>
      </mj-column>
    </mj-section>
    
    <!-- Specific Questions Section -->
    <mj-section background-color="#ffffff" padding="30px" border-radius="8px">
      <mj-column>
        <mj-text font-size="18px" color="#333333" font-weight="bold">We'd love to hear more</mj-text>
        <mj-text font-size="16px" color="#555555">
          Your detailed feedback helps us understand your needs better:
        </mj-text>
        <mj-spacer height="15px" />
        
        <mj-text color="#555555" css-class="quote-box">
          "What feature do you find most valuable in {{product_name}}?"
        </mj-text>
        <mj-spacer height="15px" />
        
        <mj-text color="#555555" css-class="quote-box">
          "Is there anything you would like to see improved?"
        </mj-text>
        <mj-spacer height="15px" />
        
        <mj-text color="#555555" css-class="quote-box">
          "How likely are you to recommend {{product_name}} to others?"
        </mj-text>
        
        <mj-button background-color="#1890ff" color="#ffffff" font-family="Arial, sans-serif" href="{{feedback_url}}" width="250px" border-radius="4px" font-weight="bold" font-size="16px" align="center" padding-top="20px">
          Share Your Feedback
        </mj-button>
      </mj-column>
    </mj-section>
    
    <!-- User testimonial -->
    <mj-section background-color="#f0f7ff" padding="30px" border-radius="8px">
      <mj-column>
        <mj-text font-size="18px" color="#333333" font-weight="bold" align="center">See what others are saying</mj-text>
        <mj-divider border-color="#1890ff" border-width="2px" width="80px" padding-bottom="10px" />
        <mj-text font-size="16px" color="#555555" font-style="italic" align="center">
          "{{product_name}} has transformed how we engage with our customers. The intuitive interface and powerful analytics have helped us increase conversion rates by 40%."
        </mj-text>
        <mj-text font-size="14px" color="#777777" font-weight="bold" align="center" padding-top="10px">
          - Jane Smith, Marketing Director at XYZ Company
        </mj-text>
      </mj-column>
    </mj-section>
    
    <!-- Thank you section -->
    <mj-section background-color="#ffffff" padding="30px" border-radius="8px">
      <mj-column>
        <mj-text font-size="16px" color="#555555">
          Thank you for being a valued customer. Your feedback directly influences our product roadmap.
        </mj-text>
        <mj-text font-size="16px" color="#555555">
          Best regards,<br />
          The {{company_name}} Team
        </mj-text>
      </mj-column>
    </mj-section>
    
    ${FOOTER_MJML}
  </mj-body>
</mjml>
`;

// Template metadata for the gallery
export default {
  id: "productFeedback",
  name: "Product Feedback Request",
  category: "product",
  description:
    "An engaging email that requests customer feedback about their product experience, featuring a user-friendly rating system and specific questions to capture valuable insights.",
  features: [
    "Interactive rating system",
    "Specific feedback questions",
    "Customer testimonial",
    "Clean, accessible design",
    "Mobile-responsive layout",
  ],
  subject: "Your Feedback Matters to Us",
  subTitle: "We'd love to hear about your experience with our product",
  mjmlTemplate: productFeedback,
};
